import { makeAutoObservable } from 'mobx';

import type { MenuItem, SettingsPageMenuService } from '../../../types';

export class MenuService implements SettingsPageMenuService {
  private pagePrefix!: string;

  constructor(public currentMenuItems: MenuItem[]) {
    makeAutoObservable(this);
  }

  initializeMenuItems(menuContext: { settingsPagePrefix: string }) {
    this.pagePrefix = menuContext.settingsPagePrefix;
    this.addDisableScrollToTopQueryParam();
  }

  selectMenuItem(selectedMenuItemLinkIdentifier: string) {
    this.currentMenuItems = this.currentMenuItems.map((menuItem) => {
      const path = this.getRelativePathItemsFromMenuItem(menuItem);

      if (path) {
        const routePathIndex = 1;
        const routePath = path[routePathIndex];

        return {
          ...menuItem,
          selected: routePath === selectedMenuItemLinkIdentifier,
        };
      }

      return menuItem;
    });
  }

  private addDisableScrollToTopQueryParam() {
    this.currentMenuItems = this.currentMenuItems.map((item) => ({
      ...item,
      link: `${item.link}?disableScrollToTop=true`,
    }));
  }

  private removeAllQueryParams(url: string) {
    return url.split('?')[0];
  }

  private getRelativePathItemsFromMenuItem(item: MenuItem) {
    if (item.link) {
      const linkWithoutQueryParams = this.removeAllQueryParams(item.link);
      const indexOfMembersAreaPagePrefix = linkWithoutQueryParams.indexOf(
        this.pagePrefix,
      );
      return linkWithoutQueryParams
        .slice(indexOfMembersAreaPagePrefix)
        .split('/');
    }

    return null;
  }
}
